/**
 * DESIGN.md § Components `skeleton`: `{colors.surface-sunken}` blocks at
 * `{rounded.sm}`, laid out in the shape of the content that is loading, at
 * the real row height, so nothing shifts when data lands (VC-2.2-15). Row
 * count and shape come from `columnCount`/`isPhone`, never from a specific
 * list — this is the same "column list and nothing else" genericism the
 * table itself follows, just for its loading shape.
 */
export function TableSkeleton({
  columnCount,
  isPhone,
  rowCount = 8,
}: {
  columnCount: number;
  isPhone: boolean;
  rowCount?: number;
}) {
  if (isPhone) {
    return (
      <div role="presentation" aria-hidden="true">
        {Array.from({ length: rowCount }, (_, row) => (
          <div key={row} className="flex h-table-row-phone flex-col justify-center gap-2 border-b border-border-hairline">
            <div className="h-3 w-1/2 rounded-sm bg-surface-sunken" />
            <div className="h-3 w-3/4 rounded-sm bg-surface-sunken" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div role="presentation" aria-hidden="true">
      {Array.from({ length: rowCount }, (_, row) => (
        <div key={row} className="flex h-table-row items-center gap-6 border-b border-border-hairline px-4">
          {Array.from({ length: columnCount }, (_, col) => (
            <div key={col} className="h-3 flex-1 rounded-sm bg-surface-sunken" />
          ))}
        </div>
      ))}
    </div>
  );
}
